import React, { useState } from 'react';
import {
  IconButton,
  Badge,
  Popover,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNotification } from './notifications';
import { logger } from "shared/logger/logger";
//import { postData } from '../api/apiclient';

const NotificationBell = () => {
  const { notifications, setNotifications } = useNotification();
  const [anchorEl, setAnchorEl] = useState(null);

  // 🔒 Sécurisation : notifications est TOUJOURS un tableau
  const safeNotifications = Array.isArray(notifications)
    ? notifications
    : [];

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAsRead = async (id) => {
    try {
      //await postData(`/notifications/mark-as-read/${id}/`);

      // 🔒 Sécurisation du state précédent
      setNotifications((prev) =>
        Array.isArray(prev)
          ? prev.map((n) =>
              n.id === id ? { ...n, is_read: true } : n
            )
          : prev
      );
    } catch (err) {
      logger.error('Error marking notification as read:', err);
    }
  };

  const unreadCount = safeNotifications.filter(
    (n) => !n.is_read
  ).length;

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: { width: 300 },
        }}
      >
        <Typography variant="h6" sx={{ padding: 2 }}>
          Notifications
        </Typography>

        <Divider />

        <List>
          {safeNotifications.length === 0 ? (
            <Typography sx={{ padding: 2 }}>
              Aucune notification
            </Typography>
          ) : (
            safeNotifications.map((notification) => (
              <ListItemButton
                key={notification.id}
                onClick={() =>
                  handleMarkAsRead(notification.id)
                }
                sx={{
                  backgroundColor: notification.is_read
                    ? '#f9f9f9'
                    : '#e0f7fa',
                  '&:hover': {
                    backgroundColor: '#b2ebf2',
                  },
                }}
              >
                <ListItemText
                  primary={notification.message}
                />
              </ListItemButton>
            ))
          )}
        </List>
      </Popover>
    </>
  );
};

export default NotificationBell;
